import { Outlet, useLoaderData } from "react-router-dom";

import SubNavigation from "../../../../../navigations/view-management/detail/sub-navigation";
import RIGHT_PANEL_TABS_TEMPLATE from "../../config/right-panel-tabs.template";

export default function DetailSubTabLayout({ viewName, parentTab, activeTab }) {
  const { id } = useLoaderData();
  const parentTabConfig = (RIGHT_PANEL_TABS_TEMPLATE[viewName] ?? []).find(
    (tab) => tab.key === parentTab
  );
  const subtabs = (parentTabConfig?.subtabs ?? []).filter((tab) =>
    typeof tab.isVisible === "function" ? tab.isVisible({ id, viewName, parentTab }) : true
  );

  return (
    <SubNavigation
      viewName={viewName}
      id={id}
      parentTab={parentTab}
      activeTab={activeTab}
      subtabs={subtabs}
    >
      <Outlet />
    </SubNavigation>
  );
}
